import { render } from "./VLabel.vue?vue&type=template&id=0ca17799"
import script from "./VLabel.vue?vue&type=script&lang=js"
export * from "./VLabel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__